export const debugMode = (() => {
  const debugValue = document.querySelector('meta[name="debug-info"]')?.getAttribute('value');
  return debugValue?.toLowerCase() === 'true';
})();

export const railsVersion = (() =>
  document.querySelector('meta[name="rails-version"]')?.getAttribute('value'))();
